import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import Truck from "../icons/mb-truck.png";

const styles = (theme) => ({
  root: {
    textAlign: "center",
  },
  truckLogo: {
    paddingBottom: theme.spacing(8),
    width: "183px",
  },
  introText: {
    fontSize: 32,
    maxWidth: 775,
    paddingBottom: theme.spacing(8),
  },
});

class Introduction extends Component {
  handleGetMoving = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "get-moving",
      eventProps: {
        category: "Ecommerce",
        action: "Click",
        label: "Page 1 - Get Moving",
      },
    });

    this.props.handleNext();
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid className={classes.root}>
        <img alt="logo" className={classes.truckLogo} src={Truck} />
        <Typography className={classes.introText}>
          Answer a few questions about your local move to receive an instant
          estimate.
        </Typography>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={this.handleGetMoving}
          endIcon={<ArrowForwardIcon />}
        >
          Get Moving
        </Button>
      </Grid>
    );
  }
}

Introduction.propTypes = {
  classes: PropTypes.object.isRequired,
  handleNext: PropTypes.func.isRequired,
};

export default withStyles(styles)(Introduction);
